import React, { useEffect, useState } from 'react';
import { DataFetcher } from './utils/dataFetcher';
import { replaceImg } from './utils/utils';

export default ({ keywords }) => {
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataFetcher = new DataFetcher();
        const list = await dataFetcher.fetchData(keywords, 0);
        const newOfferList = list.data.map(offer => {
          // 添加打点参数
          let cbu_ad_sessionid = "";
          let cbu_ad_adgroup_id = "";
          let trackInfo = offer.trackInfo;
          if (trackInfo && typeof trackInfo === "string") {
            try {
              trackInfo = JSON.parse(trackInfo);
            } catch (e) {
              console.error('Failed to parse trackInfo:', e);
              trackInfo = {};
            }
          } else if (!trackInfo) {
            trackInfo = {};
          }
          cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
          cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;
          return {
            ...offer,
            cbu_ad_sessionid,
            cbu_ad_adgroup_id,
          };
        });
        setOffers(newOfferList);
      } catch (error) {
        console.error('Failed to fetch offers:', error);
      }
    };
    fetchData();
  }, [keywords]);

  return (
    <div className='pc-offer-list'>
      {offers && offers.map((offer, index) => {
        return (
          <div
            className={'pc-offer-item offer'}
            data-jplus-exp-url={offer.impressionEurl}
            data-tracker="offer"
            data-aplus-report={`object_type@offer^object_id@${offer.offerId}^_p_isad@${(offer.eurl || offer.odUrl)?.includes("dj.1688.com") ? "1" : "0"
              }^cbu_ad_sessionid@${offer.cbu_ad_sessionid}^cbu_ad_adgroup_id@${offer.cbu_ad_adgroup_id}^isCps@${offer?.isCps
              }^offerId@${offer.offerId}^idx@${index}`}
          >
            <a key={index} className="pc-offer-item" href={offer.eurl || offer.odUrl} target="_blank">
              <div className="offer-image-wrapper">
                <img
                  src={replaceImg(offer.imgUrl || '')}
                  alt={offer.subject}
                  className="offer-image"
                />
              </div>
              <div className="offer-content">
                <span className="offer-title">{offer.subject}</span>
                <div className="offer-price">
                  <span className="price-symbol">¥</span>
                  <span className="price-value">{offer.price}</span>
                </div>
              </div>
            </a>
          </div>
        );
      })}
    </div>
  );
}
